module.exports = __webpack_public_path__ + "img/ms-icon-70x70.png";